import React from 'react';
import { Select, SelectProps, Spin } from 'antd';
import { ChevronDownIcon } from 'assets/icons/chevronDownIcon';
import 'baseComponents/MultiSelectDropdownComponent/multiSelectDropdownComponent.scss';
import { BaseOptionType, DefaultOptionType } from 'antd/es/select';
import {
  InputComponentWrapper,
  InputComponentWrapperProps,
} from 'baseComponents/InputComponentWrapper';
import { useSelectAll } from 'hooks/useSelectAll';

type MultiSelectDropdownProps<
  V extends unknown[],
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
> = SelectProps<V, OptionType> & {
  options: any[];
  onChange?: (selectedValues: V) => void;
  placeholder?: string;
  value?: V;
} & Pick<
    InputComponentWrapperProps,
    'error' | 'description' | 'fullWidth' | 'label'
  >;

export const MultiSelectDropdownComponent = <
  ValueType extends unknown[],
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
>({
  options,
  onChange,
  placeholder = 'Select options',
  value,
  error,
  description,
  label,
  fullWidth,
  loading,
}: MultiSelectDropdownProps<ValueType, OptionType>) => {
  const selectProps = useSelectAll({
    showSelectAll: true,
    value: value,
    onChange: onChange,
    options: options,
  });
  return (
    <InputComponentWrapper {...{ error, description, label, fullWidth }}>
      <Select
        showSearch={false}
        className='multi-select-dropdown'
        mode='multiple'
        placeholder={placeholder}
        suffixIcon={loading ? <Spin /> : <ChevronDownIcon />}
        popupClassName='multi-select-popup'
        status={error ? 'error' : ''}
        loading={loading}
        {...selectProps}
      />
    </InputComponentWrapper>
  );
};
